import React from "react";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../../redux/profile/action";

export default function NotificationContantButton({ profile }) {
  const dispatch = useDispatch();

  // Handle toggle on/off
  const handleToggle = () => {
    const currentStatus = profile?.preferences?.allow_notification;
    const newStatus = currentStatus == 1 ? 2 : 1;

    const data = {
      type: "preferences",
      preferences: {
        allow_notification: String(newStatus),
      },
    };

    dispatch(updateProfile(data));
  };

  return (
    <div className="slide-input">
      <label className="switch">
        <input
          type="checkbox"
          checked={profile?.preferences?.allow_notification == 1}
          onChange={handleToggle}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
}
